import { connect } from "react-redux";

import {
  reducer,
  mapStateToProps,
  mapDispatchToProps,
} from "./AdministeredUsers.state";
import AdministeredUsersTable from "./AdministeredUsersTable";

export default connect(mapStateToProps, mapDispatchToProps)(AdministeredUsersTable);

export { reducer, mapStateToProps, mapDispatchToProps };
